
import { useEffect } from "react";
import { PageRouter } from "./routes";
import { Toaster } from 'sonner'
import { SideBarTabsContextProvider } from "./contexts/sideBarTabsContext";
import { ResumeItemContextProvider } from "./contexts/resumeItemContext";
import { CoverLetterItemContextProvider } from "./contexts/coverLetterItemContext";
import { ResumeDataContextProvider } from "./contexts/resumeDataContext";
import { CoverLetterDataContextProvider } from "./contexts/coverLetterDataContext";
import { TemplateContextProvider } from "./contexts/templateContext";
import { CoverLetterTemplateContextProvider } from "./contexts/coverLetterTemplateContext";
import { ResumeFormSectionContextProvider } from "./contexts/resumeFormSectionContext";
import { BillingContextProvider } from "./contexts/billingContext";
import { ResumeSectionsContextProvider } from "./contexts/resumeSectionsContext";

import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from '@tanstack/react-query'
import tokenService from "./services/token.service";

const queryClient = new QueryClient();
// Create a GrowthBook instance
const gb = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: "sdk-abc123",
  enableDevMode: true,
  // Only required for A/B testing
  // Called every time a user is put into an experiment
  trackingCallback: (experiment, result) => {
    console.log("Experiment Viewed", {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
});
gb.init({
  // Optional, enable streaming updates
  streaming: true
})




function App() {
  const user  = tokenService.getUser();
  useEffect(() => {
    // Set user attributes for targeting (from cookie, auth system, etc.)
    gb.setAttributes({
      id: user.id,
      company: user.email,
    });
  }, [user])


  return (
    <>
      <Toaster 
      // richColors 
      position="top-right" />
      <GrowthBookProvider growthbook={gb}>
        <QueryClientProvider client={queryClient}>
          <SideBarTabsContextProvider>
            <ResumeItemContextProvider>
              <CoverLetterItemContextProvider>
                <ResumeDataContextProvider>
                  <CoverLetterDataContextProvider>
                    <TemplateContextProvider>
                      <CoverLetterTemplateContextProvider>
                        <ResumeFormSectionContextProvider>
                          <ResumeSectionsContextProvider>
                            <BillingContextProvider>
                              <PageRouter />
                            </BillingContextProvider>
                          </ResumeSectionsContextProvider>
                        </ResumeFormSectionContextProvider>
                      </CoverLetterTemplateContextProvider>
                    </TemplateContextProvider>
                  </CoverLetterDataContextProvider>
                </ResumeDataContextProvider>
              </CoverLetterItemContextProvider>
            </ResumeItemContextProvider>
          </SideBarTabsContextProvider>
        </QueryClientProvider>
      </GrowthBookProvider>
    </>
  );
}

export default App;
